import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { AccessEnum } from "~/api/GeneratedApi";
import { setTitle } from "~/redux/reducers/generalReducer";
import { useAppDispatch } from "~/redux/store/store";
import { useAccess } from "./hooks/useAccess";

type Props = RouteProps & {
  titleKey: string;
  requiredAccess?: AccessEnum | AccessEnum[];
  disabled?: boolean;
  hasBreadcrumbs?: boolean;
};

const AppRoute = ({
  children,
  titleKey,
  requiredAccess,
  disabled,
  hasBreadcrumbs,
  ...rest
}: Props): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const { hasAccess, accessesSet } = useAccess();
  const { t } = useTranslation("navigation");
  const { push } = useHistory();

  useEffect(() => {
    if (hasBreadcrumbs) return;
    dispatch(setTitle(t(titleKey)));
  }, [dispatch, titleKey, t, hasBreadcrumbs]);

  if (disabled) {
    push("/map");
    return null;
  }

  if (requiredAccess && accessesSet && !hasAccess(requiredAccess)) {
    push("/map");
    return null;
  }

  return <Route {...rest}>{children}</Route>;
};

export default AppRoute;
